export enum PhoneNumberDirection {
  IN_OUT = 'IN_OUT',
  IN = 'IN',
  OUT = 'OUT',
}
